import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Sgkb575aRequest, Sgkb575aResponse, SGKB575AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb941dSgkb575aService {
  /** 共通受付照会結果のSubject */
  private _commonAceptSearchResult$ = new Subject<Sgkb575aResponse>();

  /**
  * 共通受付照会結果のobservable提供
  *
  * @readonly
  * @memberof UsedSgkb941dSgkb575aService
  */
  get valueChanges() {
    return this._commonAceptSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKB575AService} SGKB575AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkb941dSgkb575aService
   */
  constructor(
    private sGKB575AService: SGKB575AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * 共通受付照会API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Sgkb575aResponse>}
   * @memberof UsedSgkb941dSgkb575aService
   */
  searchContractor(value: Sgkb575aRequest): Observable<Sgkb575aResponse> {
    // 検索条件を保存
    return this.sGKB575AService.SGKB575APost(<Sgkb575aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._commonAceptSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SGKB575A);
          return throwError(err.message);
        })
      );
  }
}
